import { useTranslation } from 'react-i18next';

const ITEM_COUNT = 5;

function splitParagraphs(value: string): string[] {
  return value
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export default function ChoosingChecklist() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {splitParagraphs(t('butlerTrainingSchool.checklist.label')).map((paragraph, index) => (
            <p key={index} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">
              {paragraph}
            </p>
          ))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('butlerTrainingSchool.checklist.title')}
          </h2>
          {splitParagraphs(t('butlerTrainingSchool.checklist.titleEn')).map((paragraph, index) => (
            <p key={index} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">
              {paragraph}
            </p>
          ))}
          <div className="gold-line mx-auto mb-6"></div>
          {splitParagraphs(t('butlerTrainingSchool.checklist.lead')).map((paragraph, index) => (
            <p key={index} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[720px] mx-auto">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.3fr] gap-10 items-start">
          <div className="relative w-full aspect-[4/3] overflow-hidden lg:sticky lg:top-28">
            <img
              src="/images/generated/master-household-2026.jpg"
              alt={t('butlerTrainingSchool.checklist.imgAlt')}
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          <ul className="space-y-4">
            {Array.from({ length: ITEM_COUNT }, (_, idx) => (
              <li
                key={idx}
                className="bg-background-100/60 border border-background-200/60 p-5 md:p-6 flex gap-4"
              >
                <div className="w-9 h-9 rounded-full bg-accent-500/8 border border-accent-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-[14px] text-accent-500 tracking-[0.04em]">{idx + 1}</span>
                </div>
                <div>
                  <h3 className="font-heading text-[17px] text-foreground-900 tracking-[0.05em] mb-2">
                    {t(`butlerTrainingSchool.checklist.${idx}.title`)}
                  </h3>
                  {splitParagraphs(t(`butlerTrainingSchool.checklist.${idx}.desc`)).map((paragraph, index) => (
                    <p key={index} className="text-[16px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </li>
            ))}
          </ul>
        </div>

        {splitParagraphs(t('butlerTrainingSchool.checklist.note')).map((paragraph, index) => (
          <p key={index} className="text-[14px] text-foreground-400 tracking-[0.03em] leading-relaxed max-w-[900px] mx-auto mt-10 text-center">
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
}
